/**
 * Aligent FredHopper Campaigns JS
 */
// eslint-disable-next-line import/no-dynamic-require
define(['jquery', 'handlebars', 'rwdImageMaps', 'handlebars-helpers', 'handlebars-helper-x'], ($, Handlebars) => {
    $('img[usemap]').rwdImageMaps();

    const AfCampaign = {
        templateCampaignPush($container, $xmlData) {
            const $staticContent = $xmlData.find('static-content');

            if ($staticContent[0]) {
                const type = $staticContent.attr('type');
                if (type === 'text') {
                    const templateData = {
                        slot: $staticContent.find(`custom-field[name="${AfCampaign.fhCampaignType}"]`).text(),
                        title: $staticContent
                            .children('content[name="title"]')
                            .children('content-value')
                            .text(),
                        line1: $staticContent
                            .children('content[name="line1"]')
                            .children('content-value')
                            .text(),
                        line2: $staticContent
                            .children('content[name="line2"]')
                            .children('content-value')
                            .text(),
                        url: decodeURIComponent(
                            $staticContent
                                .find('content[name="title"]')
                                .children('content-link')
                                .text()
                        )
                    };
                    const source = $('#aligent_fredhopper-handlebars-campaign-text').html();
                    if (source) {
                        const template = Handlebars.compile(source);

                        const html = template(templateData);
                        $($container).append(html);
                    }
                } else if (type === 'image') {
                    const templateData = {
                        slot: $staticContent.find(`custom-field[name="${AfCampaign.fhCampaignType}"]`).text(),
                        items: []
                    };
                    $.each($staticContent.find('content'), (i, el) => {
                        const $image = $(el);
                        templateData.items.push({
                            image: $image.children('content-value').text(),
                            url: $image.children('content-link').text(),
                            alt: $image.children('content-link').attr('alt')
                        });
                    });
                    const source = $('#aligent_fredhopper-handlebars-campaign-image').html();
                    if (source) {
                        const template = Handlebars.compile(source);

                        const html = template(templateData);
                        $($container).append(html);
                    }
                } else if (type === 'image-map') {
                    const $staticContent = $staticContent.children('content');

                    const templateData = {
                        slot: $staticContent.find(`custom-field[name="${AfCampaign.fhCampaignType}"]`).text(),
                        id: $xmlData.attr('id'),
                        img: $staticContent.children('content-value').text(),
                        areas: []
                    };
                    $.each($staticContent.children('content-area-link'), (i, linkElement) => {
                        const $area = $(linkElement);
                        templateData.areas.push({
                            url: decodeURIComponent($area.text()),
                            x1: $area.attr('x1'),
                            y1: $area.attr('y1'),
                            x2: $area.attr('x2'),
                            y2: $area.attr('y2'),
                            alt: $area.attr('alt'),
                            target: $area.attr('open-in-new-window') == 'true' ? '_blank' : '_self'
                        });
                    });
                    const source = $('#aligent_fredhopper-handlebars-campaign-image-map').html();
                    if (source) {
                        const template = Handlebars.compile(source);

                        const html = template(templateData);
                        $($container).append(html);
                        $($container)
                            .find('img[usemap]')
                            .rwdImageMaps();
                    }
                }
            } else {
                const $items = $xmlData.find('items item');
                if ($items[0]) {
                    const templateData = {
                        slot: $xmlData.find(`custom-field[name="${AfCampaign.fhCampaignType}"]`).text(),
                        items: []
                    };
                    $.each($items, function eachItem(i) {
                        const itemData = {
                            index: i,
                            themeId: $items[i].parentNode.parentNode.getAttribute("id")
                        };
                        $.each($(this).find('attribute'), function eachAttr() {
                            const $attribute = $(this);

                            const attributeName = $attribute.attr('name');
                            if (typeof itemData[attributeName] === 'undefined') {
                                itemData[attributeName] = $attribute.children('value').text();
                            }
                        });
                        templateData.items.push(itemData);
                    });
                    const source = $('#aligent_fredhopper-handlebars-campaign-items').html();
                    if (source) {
                        const template = Handlebars.compile(source);
                        const html = template(templateData);
                        $($container).append(html);
                    }
                }
            }
        },

        templateCampaigns() {
            const $data = $(AfCampaign.load.data).find(`universe[name="${AfCampaign.config.universe}"] themes theme`);
            $.each($data, (i, element) => {
                const fhCampaignType = $(element)
                    .find(`custom-field[name="${AfCampaign.config.fhCampaignType}"]`)
                    .text();
                const $container = $(`#aligent_fredhopper-campaign-${fhCampaignType}`);
                if ($container.length > 0) {
                    AfCampaign.templateCampaignPush($container, $(element));
                }
            });

            if (typeof AfCampaign.config.afterSuccess === 'function') {
                AfCampaign.config.afterSuccess($(AfCampaign.load.data).find('page'));
            }
        },

        pushDataLayerPDP() {
            // Push page RID for FH to DataLayer
            const $pageRid = $(AfCampaign.load.data).find(`page`);
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                "fredhopperPdpPageRid": $pageRid[0].getAttribute('rid'),
                'event': 'fhPdpRid'
            });
        }
    };

    return function AfCampaignInit(config) {
        AfCampaign.config = config;
        AfCampaign.element = '#xml-aligent_fredhopper-campaign-results';
        AfCampaign.load = {};

        const $xmlResults = $(AfCampaign.element);

        if (!AfCampaign.load.data) {
            AfCampaign.load.data = $($xmlResults.html())[2];
        }
        if (!AfCampaign.load.data) {
            const data = {
                fh_view: AfCampaign.config.fhView
            };
            if (AfCampaign.config.fhSecondId) {
                data.fh_secondid = AfCampaign.config.fhSecondId;
            }
            AfCampaign.load.ajax = $.ajax({
                url: '/fredhopper/request/fas/',
                dataType: 'xml',
                cache: true,
                data,
                beforeSend() {
                    // abort the Ajax request, if another one has appeared
                    if (AfCampaign.load.ajax != null) {
                        AfCampaign.load.ajax.abort();
                    }
                },
                success(data, textStatus, jqXHR) {
                    // save information
                    AfCampaign.load.query = decodeURIComponent(
                        $(data)
                            .find('info query-string-httpencoded')
                            .text()
                    );
                    AfCampaign.load.data = data;

                    AfCampaign.pushDataLayerPDP();
                    AfCampaign.templateCampaigns();
                }
            });
        } else {
            AfCampaign.load.query = decodeURIComponent(
                $(AfCampaign.load.data)
                    .find('info query-string-httpencoded')
                    .text()
            );
            AfCampaign.templateCampaigns();
        }
    };
});
